import { ExportType } from '@/modules/ta/reportstudio/reportstudio.constants';

export const getters = {
  /**
   * @param {ExportState} state
   * @returns {boolean}
   */
  isExporting(state) {
    return state.isExporting;
  },
  /**
   * @param {ExportState} state
   * @returns {boolean}
   */
  isScheduledExport(state) {
    if (state.config?.exportType) {
      return state.config.exportType === ExportType.TYPE_SCHEDULED_REPORT_PDF;
    }

    return false;
  },
  isSingleWidgetExport(state) {
    return state.config?.isExportingSingleWidget;
  },
  isCompactPPTExport(state) {
    return state.config?.pptTitleSlide;
  },
  /**
   * @param {ExportState} state
   * @returns {{}}
   */
  getConfig(state) {
    return state.config;
  },
  /**
   * exports are either used as html in the browser or puppeteer
   * @returns {boolean}
   */
  getIsCapturing({ config }) {
    return !config.isHtml;
  },
  /**
   * if a widget is a "ghost" widget it'll exist in this map
   * @param state
   * @param widgetId
   * @returns {*}
   */
  getGhostWidget(state, widgetId) {
    return state.ghostWidgets[widgetId];
  },
  /**
   * Header of a paginated-datagrid container: its render-ready signal is owned by
   * ExportPaginatedAppendedWidgets.vue's clone, not its live mount (TR-7221).
   *
   * @param {ExportState} state
   * @param {number} widgetId
   * @returns {boolean}
   */
  isPaginatedHeaderWidget(state, widgetId) {
    return Object.values(state.paginatedWidgets).some((containers) =>
      containers.some((container) => container.header?.id === widgetId)
    );
  },
  /**
   * @param {ExportState} state
   * @param {number} widgetId datagrid widget id
   * @returns {?number} id of the media widget appended above it, if any
   */
  getPaginatedHeaderId(state, widgetId) {
    const container = Object.values(state.paginatedWidgets)
      .flat()
      .find((item) => item.widget?.id === widgetId);
    return container?.header?.id ?? null;
  },
};
